<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import InlineFileUpload from "./uploads/InlineFileUpload.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "GeneralInformation",
  components: {
    Multiselect,
    InlineFileUpload,
  },
  data() {
    return {
      floppyDisk,
      editPortrait: false,
      editLandscape: false,
      id: this.$route.params.id ? this.$route.params.id : null,
      staticUsersOptions: [
        {
          value: "Sam Gowing",
          text: "Sam",
        },
        {
          value: "Xali",
          text: "Xali",
        },
        {
          value: "Naz",
          text: "Naz",
        },
        {
          value: "Guest",
          text: "Guest",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentRecipe: "recipes/currentRecipe",
      categoriesFieldOptions: "recipes/categoriesFieldOptions",
      storageOptions: "recipes/storageOptions",
      dietaryOptions: "recipes/dietaryOptions",
      intentionsOptions: "recipes/intentionsOptions",
      goalOptions: "recipes/goalOptions",
      effectsOptions: "recipes/effectsOptions",
      mealTimeOptions: "recipes/mealTimeOptions",
      recipeOptions: "recipes/recipeOptions",
      recipeErrors: "recipes/recipeErrors",
      usersOptions: "recipes/usersOptions",
      recipesOptions: "recipes/recipesOptions",
    }),

    sortedCategoriesFieldOptions: function () {
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      return this.categoriesFieldOptions.sort(compare);
    },
    sortedStorageOptions: function () {
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      return this.storageOptions.sort(compare);
    },
    sortedDietaryOptions: function () {
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      return this.dietaryOptions.sort(compare);
    },
    sortedIntentionsOptions: function () {
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      return this.intentionsOptions.sort(compare);
    },
    sortedGoalOptions: function () {
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      return this.goalOptions.sort(compare);
    },

    sortedUsersOptions: function () {
      var users = [];
      function compare(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      }
      users = this.usersOptions.sort(compare);
      users.push({ value: "guest", text: `Guest` });
      return users;
    },

    title: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "title",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.title) {
          return this.currentRecipe.title;
        }
        return "";
      },
    },
    description: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "description",
          value,
        });
      },
      get() {
        if (this.currentRecipe.description) {
          return this.currentRecipe.description;
        }
        return "";
      },
    },
    meal_times: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "meal_times",
          value,
        });
      },
      get() {
        if (this.currentRecipe.meal_times) {
          return this.currentRecipe.meal_times;
        }
        return "";
      },
    },
    categories: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "categories",
          value,
        });
      },
      get() {
        if (this.currentRecipe.categories) {
          return this.currentRecipe.categories;
        }
        return "";
      },
    },
    storage: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "storage",
          value,
        });
      },
      get() {
        if (this.currentRecipe.storage) {
          return this.currentRecipe.storage;
        }
        return "";
      },
    },
    related_recipes: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "related_recipes",
          value,
        });
      },
      get() {
        if (this.currentRecipe.related_recipes) {
          return this.currentRecipe.related_recipes;
        }
        return "";
      },
    },
    resource: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "resource",
          value,
        });
      },
      get() {
        if (this.currentRecipe.resource) {
          return this.currentRecipe.resource;
        }
        return "";
      },
    },
    internal_notes: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "internal_notes",
          value,
        });
      },
      get() {
        if (this.currentRecipe.internal_notes) {
          return this.currentRecipe.internal_notes;
        }
        return "";
      },
    },
    video: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "video",
          value,
        });
      },
      get() {
        if (this.currentRecipe.video) {
          return this.currentRecipe.video;
        }
        return "";
      },
    },
    featured_image_portrait: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "featured_image_portrait",
          value,
        });
      },
      get() {
        if (this.currentRecipe.featured_image_portrait) {
          return this.currentRecipe.featured_image_portrait;
        }
        return "";
      },
    },
    featured_image_landscape: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "featured_image_landscape",
          value,
        });
      },
      get() {
        if (this.currentRecipe.featured_image_landscape) {
          return this.currentRecipe.featured_image_landscape;
        }
        return "";
      },
    },
    dietary_preferences: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "dietary_preferences",
          value,
        });
      },
      get() {
        if (this.currentRecipe.dietary_preferences) {
          return this.currentRecipe.dietary_preferences;
        }
        return "";
      },
    },
    protein: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "protein",
          value,
        });
      },
      get() {
        if (this.currentRecipe.protein) {
          return this.currentRecipe.protein;
        }
        return "";
      },
    },
    effects: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "effects",
          value,
        });
      },
      get() {
        if (this.currentRecipe.effects) {
          return this.currentRecipe.effects;
        }
        return "";
      },
    },

    intentions: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "intentions",
          value,
        });
      },
      get() {
        if (this.currentRecipe.intentions) {
          return this.currentRecipe.intentions;
        }
        return "";
      },
    },

    goals: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "goals",
          value,
        });
      },
      get() {
        if (this.currentRecipe.goals) {
          return this.currentRecipe.goals;
        }
        return "";
      },
    },
    author: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "author",
          value,
        });
      },
      get() {
        if (this.currentRecipe.author) {
          return this.currentRecipe.author;
        }
        return "";
      },
    },
    guest: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "guest",
          value,
        });
      },
      get() {
        if (this.currentRecipe.guest) {
          return this.currentRecipe.guest;
        }
        return "";
      },
    },
  },
  methods: {
    tabStatus(status) {
      this.$store.commit(`recipes/setTabStatus`, status);
    },
    createRecipe() {
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("recipes/createRecipe", this.currentRecipe).then(
        (res) => {
          this.getToasterResponse();
        },
        (error) => {
          console.log(error);
        }
      );
    },

    updateRecipe() {
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("recipes/updateRecipe", this.$route.params.id).then(
        (res) => {
          this.getToasterResponse();
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getToasterResponse() {
      if (this.recipeErrors.title) {
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          Array.isArray(this.recipeErrors.title)
            ? this.recipeErrors.title[0]
            : this.recipeErrors.title
        );
      } else if (this.recipeErrors.description) {
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          Array.isArray(this.recipeErrors.description)
            ? this.recipeErrors.description[0]
            : this.recipeErrors.description
        );
      } else if (this.recipeErrors.categories) {
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          "Select at least one Category"
        );
      }
      if (
        this.recipeErrors.title == null &&
        this.recipeErrors.description == null
      ) {
        this.$store.commit(`commons/setSavingForm`, "Saved");
        this.tabStatus(false);
        this.$store.commit("commons/setPreloader", false);
      }
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
        appendToast: true,
      });
    },
    handleFileUploaded(file) {
      this.featured_image_portrait = file;
      this.editPortrait = false;
    },
    handleLandscapeFileUploaded(file) {
      this.featured_image_landscape = file;
      this.editLandscape = false;
    },
    editPortraitFunc() {
      this.editPortrait = true;
    },
    trashPortraitFunc() {
      this.editPortrait = true;
    },

    editLandscapeFunc() {
      this.editLandscape = true;
    },
  },
  watch: {
    title() {
      this.tabStatus(true);
    },
    description() {
      this.tabStatus(true);
    },
    categories() {
      this.tabStatus(true);
    },
    storage() {
      this.tabStatus(true);
    },
    related_recipes() {
      this.tabStatus(true);
    },
    dietary_preferences() {
      this.tabStatus(true);
    },
    effects() {
      this.tabStatus(true);
    },
    author() {
      this.tabStatus(true);
    },
    resource() {
      this.tabStatus(true);
    },
    video() {
      this.tabStatus(true);
    },
    internal_notes() {
      this.tabStatus(true);
    },
    featured_image_portrait() {
      this.tabStatus(true);
    },
    featured_image_landscape() {
      this.tabStatus(true);
    },
  },
  
  async mounted() {
    this.$store.dispatch(`recipes/getFieldOptions`);
    this.$store.dispatch(`recipes/getRecipesOptions`);
    this.$store.dispatch(`recipes/getDietaryOptions`);
  },
};
</script>
<style lang="scss">
.recipe {
  .uppy-Dashboard-inner {
    height: 240px !important;
  }
}
.column {
  .left {
    width: 300px;
  }
  .right {
    width: calc(100% - 330px);
    margin-left: 30px;
  }
}
.thumbnail {
  &.upload-wrapper {
    position: relative;
    button {
      position: absolute;
      border: 0;
      border-radius: 50%;
      padding: 5px;
      width: 40px;
      height: 40px;
      color: #fff;

      &.edit {
        background: rgba(63, 150, 152, 0.7);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        &:hover {
          background: rgba(63, 150, 152, 1);
        }
      }
      &.trash {
        background: rgba(219, 40, 40, 0.7);
        bottom: 5px;
        right: 5px;
        &:hover {
          background: rgba(219, 40, 40, 1);
        }
      }
    }
  }
}
.multiselect-tags-search {
  height: 20px !important;
}
</style>
<template>
  <div class="py-5 px-5">
    <div class="container recipe">
      <div class="row">
        <div class="col-md-8">
          <b-form-group label="RECIPE TITLE" label-for="title">
            <b-form-input
              id="title"
              v-model="title"
              placeholder="Eg: Teriyaki chicken drumsticks with seaweed slaw"
              :class="this.recipeErrors.title ? 'is-invalid' : ''"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="DESCRIPTION" label-for="description">
            <b-form-textarea
              v-model="description"
              id="description"
              placeholder="Enter description here..."
              rows="3"
              max-rows="6"
              :class="this.recipeErrors.description ? 'is-invalid' : ''"
            ></b-form-textarea>
          </b-form-group>

          <div class="form-group">
            <label class="d-block text-uppercase">Category</label>
            <multiselect
              :class="this.recipeErrors.categories ? 'is-invalid' : ''"
              :options="sortedCategoriesFieldOptions"
              v-model="categories"
              label="text"
              track-by="text"
              mode="tags"
              :searchable="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value">
                  {{ value.text }}
                </div>
              </template>
            </multiselect>
          </div>

          <div class="form-group">
            <label class="d-block text-uppercase">STORAGE</label>
            <multiselect
              :options="sortedStorageOptions"
              v-model="storage"
              label="text"
              track-by="text"
              mode="tags"
              :searchable="true"
            >
              <template v-slot:singlelabel="{ value }">
                <div class="multiselect-single-label" v-if="value">
                  {{ value.text }}
                </div>
              </template>
            </multiselect>
          </div>

          <div class="">
            <div class="mb-4">
              <label class="d-block text-uppercase">Related Recipes</label>
              <multiselect
                v-model="related_recipes"
                :options="recipesOptions"
                :searchable="true"
                label="text"
                track-by="text"
                :create-tag="true"
                mode="tags"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label" v-if="value">
                    {{ value.text }}
                  </div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group">
            <label class="d-block text-uppercase" id="dietary_preferences"
              >Dietary Preferences</label
            >
            <multiselect
              v-model="dietary_preferences"
              :options="sortedDietaryOptions"
              mode="tags"
              label="text"
              track-by="text"
            ></multiselect>
          </div>
        </div>
        <div class="col-md-4">
          <h3>PORTRAIT</h3>
          <div
            v-if="currentRecipe.featured_image_portrait && !editPortrait"
            class="mt-1 portrait image-wrapper"
            :style="{
              backgroundImage:
                'url(\'' + currentRecipe.featured_image_portrait + '\')',
            }"
          >
            <button @click="editPortraitFunc()" class="edit">
              <b-icon icon="pencil" />
            </button>
          </div>
          <inline-file-upload
            v-if="!currentRecipe.featured_image_portrait || editPortrait"
            :allowMultipleUploads="false"
            v-on:file-uploaded="handleFileUploaded"
          >
          </inline-file-upload>

          <h3 class="mt-4">LANDSCAPE</h3>
          <div
            v-if="currentRecipe.featured_image_landscape && !editLandscape"
            class="mt-1 image-wrapper landscape"
            :style="{
              backgroundImage:
                'url(\'' + currentRecipe.featured_image_landscape + '\')',
            }"
          >
            <button @click="editLandscapeFunc()" class="edit">
              <b-icon icon="pencil" />
            </button>
          </div>

          <inline-file-upload
            v-if="!currentRecipe.featured_image_landscape || editLandscape"
            :allowMultipleUploads="false"
            v-on:file-uploaded="handleLandscapeFileUploaded"
          >
          </inline-file-upload>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label class="d-block text-uppercase" id="effects">Benefits</label>

            <b-form-group>
              <b-form-checkbox-group
                v-model="effects"
                :options="effectsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
            <!-- <multiselect
              v-model="effects"
              :options="effectsOptions"
              mode="tags"
              label="text"
              track-by="text"
            ></multiselect> -->
          </div>

          <!-- <div class="form-group">
            <label class="d-block text-uppercase" id="intentions"
              >intentions</label
            >
            <multiselect
              v-model="intentions"
              :options="sortedIntentionsOptions"
              mode="tags"
              label="text"
              track-by="text"
            ></multiselect>
          </div> -->
          <!-- 
          <div class="form-group">
            <label class="d-block text-uppercase" id="goals">goals</label>
            <multiselect
              v-model="goals"
              :options="sortedGoalOptions"
              mode="tags"
              label="text"
              track-by="text"
            ></multiselect>
          </div> -->

          <div class="column d-flex">
            <div class="left">
              <div class="form-group">
                <label class="d-block text-uppercase">Author</label>
                <multiselect
                  :options="staticUsersOptions"
                  v-model="author"
                  label="text"
                  track-by="text"
                >
                  <template v-slot:singlelabel="{ value }">
                    <div class="multiselect-single-label" v-if="value">
                      {{ value.text }}
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="right">
              <b-form-group label="RESOURCES" label-for="resources">
                <b-form-input
                  id="resources"
                  v-model="resource"
                  placeholder="Add a link"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="column d-flex">
            <div class="left">
              <b-form-group label="VIDEO (BrightcoveID)" label-for="video">
                <b-form-input
                  id="video"
                  v-model="video"
                  placeholder="Enter BrightcoveID"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-form-group label="INTERNAL NOTES" label-for="internal_notes">
            <b-form-textarea
              v-model="internal_notes"
              id="internal_notes"
              placeholder="Enter Internal Notes here..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </div>
      <button
        class="floating-btn btn no-outline"
        @click="createRecipe()"
        v-if="!id"
      >
        <span class="d-flex justify-content-center align-items-center">
          <img :src="floppyDisk" />
        </span>
      </button>
      <button
        class="floating-btn btn no-outline"
        @click="updateRecipe()"
        v-if="id"
      >
        <span class="d-flex justify-content-center align-items-center">
          <img :src="floppyDisk" />
        </span>
      </button>
    </div>
  </div>
</template>